import {createAction} from '@reduxjs/toolkit';
import {Noti} from 'generated/JavaTOmodifications';

const NAMESPACE = 'NOTI/'
export const notiRefreshAction = createAction(NAMESPACE + 'refresh')
export const notiResponseAction = createAction<Noti[]>(NAMESPACE + 'response')
export const notiMarkReadAction = createAction<{ id: number, read: boolean, onlyLocal?: boolean }>(NAMESPACE + 'markRead')
export const notiDeleteAction = createAction<number>(NAMESPACE + 'delete')